import { getChainById } from './viem-chain-map';
export const getWalletExplorerUrl = (chainId, address) => {
    const explorerUrl = getChainById(chainId)?.blockExplorers?.default.url;
    return explorerUrl ? new URL(`address/${address}`, explorerUrl).toString() : null;
};
//# sourceMappingURL=explorer-url.js.map